import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import OcAdminApp from "./OcAdminApp";
import OcErrorBoundary from "./components/OcErrorBoundary";
import "./styles/oc-admin-globals.css";

const ocQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60_000,   // 2 min — back-navigation is instant within window
      gcTime:   10 * 60_000,   // 10 min — keep data in memory between page visits
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("oc-admin-root");
if (!rootEl) throw new Error("Missing #oc-admin-root mount point");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <OcErrorBoundary>
      <QueryClientProvider client={ocQueryClient}>
        <BrowserRouter>
          <OcAdminApp />
        </BrowserRouter>
      </QueryClientProvider>
    </OcErrorBoundary>
  </React.StrictMode>,
);
